import { MetricConverter } from './helpers';
import { ConvertArgs } from './types';

class AccuracyConverter extends MetricConverter<'%', '%'> {
    baseUnit = '%' as const;
    units = ['%'] as const;

    toBase = returnSameValue;
    toBest = returnSameValue;
    convert = returnSameValue as <TUnit extends '%'>(args: ConvertArgs<'%', TUnit>) => { value: number; unit: TUnit };
}

const returnSameValue = ({ value }: { value: number }): { value: number; unit: '%' } => ({ value, unit: '%' });

export const accuracyConverter = new AccuracyConverter();
